import { list } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const MU_NEVYRIZENE_LIST = "muNevyrizeneList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestsByIds(ids);
};

const getMuNevyrizeneAllIds = (parent, filter) => {
  return QSignDataApi.findNevyrizenePozadavkyPodepisujici();
};

export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(
        MU_NEVYRIZENE_LIST,
        null,
        getMuNevyrizeneAllIds,
        getRequestsByIds,
        forceFetch
      )
    );
  };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(MU_NEVYRIZENE_LIST, getRequestsByIds));
  };
}
export function invalidateMuNevyrizene() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(MU_NEVYRIZENE_LIST));
  };
}
export function filterUkoly(filter) {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.filter(MU_NEVYRIZENE_LIST, filter));
  };
}
